// 書面本文の簡易記法をパースする。
//   「# 」始まり  → 見出し
//   「- 」始まり  → 箇条書き（先頭2スペースのインデントで入れ子）
//   それ以外      → 段落
//   {{name}}      → 署名者の氏名に置換
export function renderPlaceholders(body, values = {}) {
  return String(body || '').replace(/\{\{(\w+)\}\}/g, (match, key) => {
    const value = values[key];
    return value === undefined || value === null || value === '' ? '＿＿＿＿' : String(value);
  });
}

export function parseDocumentBody(body) {
  const lines = String(body || '').replace(/\r\n/g, '\n').split('\n');
  const blocks = [];
  let list = null;

  const flushList = () => {
    if (list) {
      blocks.push(list);
      list = null;
    }
  };

  lines.forEach((rawLine) => {
    const line = rawLine.replace(/\s+$/, '');

    if (!line.trim()) {
      flushList();
      return;
    }

    const heading = /^#\s+(.*)$/.exec(line.trim());
    if (heading) {
      flushList();
      blocks.push({ type: 'heading', text: heading[1] });
      return;
    }

    const item = /^(\s*)-\s+(.*)$/.exec(line);
    if (item) {
      const level = Math.min(Math.floor(item[1].length / 2), 1);
      if (!list) list = { type: 'list', items: [] };
      list.items.push({ level, text: item[2] });
      return;
    }

    flushList();
    blocks.push({ type: 'paragraph', text: line.trim() });
  });

  flushList();
  return blocks;
}
